import React from 'react';
import ReactGA from 'react-ga';
import { Provider } from 'react-redux';
import { ChakraProvider } from "@chakra-ui/react";
import { ConnectedRouter } from 'connected-react-router';
import Router from './router/index';
import { history, store } from './modules/store/index';
import './App.css';
import "react-datepicker/dist/react-datepicker.css";
import './assets/css/index.css'

import customTheme from './config/theme';

ReactGA.initialize('UA-57866648-12');
history.listen((location) => {
	ReactGA.set({ page: location.pathname }); // Update the user's current page
	ReactGA.pageview(location.pathname); // Record a pageview for the given page
});

function App() {	
  return (
	<ChakraProvider theme={customTheme}>
		<Provider store={store}>
			<ConnectedRouter history={history}>
				<Router />
			</ConnectedRouter>
		</Provider>
	</ChakraProvider>
	// <ThemeProvider />
  );
}

export default App;